import styled from 'styled-components';
import { SpinLoading } from 'antd-mobile';
const Loading = () => {
    return (
        <LoadingContainer>
            <SpinLoading />
        </LoadingContainer>
    )
}

const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;
`;
export default Loading;